'use es6';

import enviro from 'enviro';
var isUI = window.location.origin.indexOf('app.hubspotqa.com') > -1;
var APP_ROOT = enviro.deployed() && !isUI ? '/' : '/websitegrader/';
var LANG_REGEX = /^\/(de|en|pt|ja|es|fr)/gm;
export var getAppRoot = function getAppRoot() {
  var lang = window.I18N_MANUAL_LANG;

  if (lang === 'en') {
    return APP_ROOT;
  }

  return "" + lang + APP_ROOT;
};
export var parseUtmParams = function parseUtmParams() {
  if (!window.location.search) return '';
  var searchParams = window.location.search.slice(1).split('&').filter(function (param) {
    return param.indexOf('utm_') !== -1;
  });
  return searchParams.join('&');
};
export var getSearchParams = function getSearchParams() {
  if (!window.location.search) return '';
  return window.location.search;
};
export var getLocalizedUrl = function getLocalizedUrl(lang) {
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname,
      search = _window$location.search;
  var path = pathname.replace(LANG_REGEX, '');
  var langFragment = lang === 'en' ? '' : "/" + lang;
  return "" + origin + langFragment + path + search;
};